module.exports = __webpack_public_path__ + "static/media/student-smart.3d6cc264.svg";